import { Link } from "@tanstack/react-router";
import { cn } from "@/utils/cn";

export function Text({
	className,
	...props
}: React.ComponentPropsWithoutRef<"p">) {
	return (
		<p
			data-slot="text"
			{...props}
			className={cn(
				"text-base/6 text-muted-foreground sm:text-sm/6",
				className,
			)}
		/>
	);
}

export function TextLink({
	className,
	...props
}: React.ComponentPropsWithoutRef<typeof Link>) {
	if (props.href) {
		return (
			<a
				{...(props as React.ComponentPropsWithoutRef<"a">)}
				className={cn(
					"text-foreground underline decoration-foreground/50 data-hover:decoration-foreground",
					className,
				)}
			/>
		);
	}

	return (
		<Link
			{...props}
			className={cn(
				className,
				"text-foreground underline decoration-foreground/50 data-hover:decoration-foreground",
			)}
		/>
	);
}

export function Strong({
	className,
	...props
}: React.ComponentPropsWithoutRef<"strong">) {
	return (
		<strong
			{...props}
			className={cn(className, "font-medium text-foreground")}
		/>
	);
}

export function Code({
	className,
	...props
}: React.ComponentPropsWithoutRef<"code">) {
	return (
		<code
			{...props}
			className={cn(
				className,
				"rounded-sm border border-foreground/10 bg-foreground/2.5 px-0.5 font-medium text-sm text-foreground sm:text-[0.8125rem]",
			)}
		/>
	);
}
